<template>
  <Kyc :data-component="$options.name" />
</template>
<script>
import Kyc from '@/views/Kyc/index.vue'

export default {
  name: 'LayoutKyc',
  components: {
    Kyc
  }
}
</script>
